import { Component, OnInit, OnDestroy, ChangeDetectorRef, Injector, inject, ViewEncapsulation } from '@angular/core';
import { AppComponentBase } from '../../../../../shared/app-component-base';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../../../../test/service/login.service';
import { Observable, Subject } from 'rxjs';


@Component({
  selector: 'kt-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent  {

 

  constructor(
 
  ) { 

  
    
  }
  

  

  
}
